import GameList from '~/client/shared/game/GameList';
import LazyLoad from '~/client/shared/LazyLoad';
import PageTitle from '~/client/shared/PageTitle';
import Stack from '~/client/shared/Stack';
import HowToUseText from './HowToUseText';
import InfoContainer from './InfoContainer';
import TopGamesContainer from './TopGamesContainer';

const LiveRtpGameList: FC = () => (
  <Stack>
    <PageTitle translateId="casino.menu_item.live-rtp" />
    <Stack space="large">
      <InfoContainer>
        <HowToUseText />
      </InfoContainer>
      <TopGamesContainer />
      <LazyLoad>
        <GameList
          isLiveRtp
          pageTitle="casino.popular_games_with_live_rtp"
          menuItem="live-rtp"
          pageSection="main"
        />
      </LazyLoad>
    </Stack>
  </Stack>
);

export default LiveRtpGameList;
